import React, { Fragment, useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { simpleDateFormatter } from "../utils/helper.js";
import { DayPicker } from "react-day-picker";
import API from "../../services/axiosInstance.js";
import Select from "react-select";
import { DiffDetail, actionTypeLabel, friendlyFieldName, getDiff, } from "./trPanelConfig.js"
import "./trPanelLogs.css"
import { FormLoader, useFormLoader } from "../common_modules/loader.js";
import { Link } from "react-router-dom";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import JsonView from "@uiw/react-json-view";

const TrPanelLogs = () => {
    const [range, setRange] = useState();
    const [show, setShow] = useState(false);
    const [userList, setUserList] = useState([]);
    const [user, setUser] = useState("");
    const [date, setDate] = useState({ startDate: "", endDate: "" });
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedRow, setExpandedRow] = useState(null);
    const [error, setError] = useState("");
    const [actionTypeCode, setActionTypeCode] = useState("");
    const [showJSON, setShowJSON] = useState(false);
    const [jsonChanges, setJsonChanges] = useState({
        changes: "",
        oldChanges: ""
    });


    const { t } = useTranslation();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    const today = new Date();

    const minDate = new Date();
    minDate.setDate(today.getDate() - 70); // last 30 days

    const handleClose = (clear = false) => {
        setShow(false);
        if (clear) setRange(undefined);
    };

    const handleCloseJSON = () => {
        setShowJSON(false);
        setJsonChanges({
            changes: "",
            oldChanges: ""
        })
    };

    const handleShowJSON = (changes, oldChanges) => {
        setShowJSON(true);
        setJsonChanges({
            changes: changes,
            oldChanges: oldChanges
        })
    };

    const applyCustomDate = () => {
        if (!range?.from || !range?.to) return;
        setDate({
            startDate: simpleDateFormatter(range.from, 0).concat(" 00:00"),
            endDate: simpleDateFormatter(range.to, 0).concat(" 23:59"),
        });
        handleClose();
    };

    const toggleRow = (id) => setExpandedRow((prev) => (prev === id ? null : id));

    const getUserList = async () => {
        startLoading();
        try {
            const response = await API.get("/tech/users/user/list/limited");
            if (response.status === 200) setUserList(response?.data?.data || []);
        } catch (err) {
            console.error("Failed to fetch users:", err);
        } finally {
            stopLoading();
        }
    };

    const submit = async () => {
        startLoading();
        setError("");
        setLogs([]);
        setExpandedRow(null);
        try {
            const payload = {
                userName: user || "",
                startData: date.startDate,
                endData: date.endDate,
            };

            if (!payload.startData || !payload.endData) {
                setError("Select date range.");
                return false;
            }

            const response = await API.post("/tracker/filter", payload);
            if (response.status === 200) {
                const result = response?.data?.data || [];
                setLogs(result);
                if (result.length === 0) setError("No logs found for the selected filters.");
            }
        } catch (err) {
            console.error(err);
            setError("Failed to load logs. Please try again.");
        } finally {
            stopLoading();
        }
    };

    useEffect(() => { getUserList(); }, []);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
                style={{ padding: 24, fontFamily: "system-ui, sans-serif", background: "#f8fafc", minHeight: "100vh" }}>
                {/* Header */}
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <span>Tech Admin</span>
                    <span>Tr Panel Logs</span>
                </div>
                <h4 style={{ fontWeight: 700, fontSize: 20, color: "#0f172a", marginBottom: 20 }}>
                    📋 Tr Panel Logs
                    {logs.length > 0 && (
                        <span style={{ fontSize: 13, fontWeight: 400, color: "#64748b", marginLeft: 10 }}>
                            {logs.length} record{logs.length !== 1 ? "s" : ""}
                        </span>
                    )}
                </h4>

                {/* Filter Bar */}
                <div style={{ background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 12, padding: "18px 22px", marginBottom: 24 }}>
                    <Row className="align-items-end g-3">
                        <Col md={3}>
                            <Form.Label>User</Form.Label>
                            <Select
                                options={[
                                    { value: "", label: "ALL USERS" },
                                    ...userList.map((item) => ({ value: item.userId, label: `${item.userId.toUpperCase()}` })),
                                ]}
                                defaultValue={[{ value: "", label: "ALL USERS" }]}
                                onChange={(selected) => setUser(selected?.value || "")}
                                // placeholder="Search user..."
                                isSearchable
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({ ...base, fontSize: 13, borderColor: "#e2e8f0", boxShadow: "none" }),
                                }}
                            />
                        </Col>

                        <Col md={4}>
                            <Form.Label>Date Range</Form.Label>
                            <Button
                                variant="outline-secondary"
                                className="w-100 text-start"
                                style={{ fontSize: 13, borderColor: "#e2e8f0", color: "#475569", height: "38px", background: "transparent" }}
                                onClick={() => setShow(true)}
                            >
                                {range?.from && range?.to
                                    ? `${simpleDateFormatter(range.from, 0).replaceAll("-", "/")} → ${simpleDateFormatter(range.to, 0).replaceAll("-", "/")}`
                                    : "📅 Select Date Range"}
                            </Button>
                        </Col>

                        <Col md={3}>
                            <Button onClick={submit}
                                style={{ width: "50%", background: "#193c8d", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, padding: "9px 0" }}>
                                Generate Logs <LuSquareArrowOutUpRight />
                            </Button>
                        </Col>
                    </Row>
                </div>

                {/* Error */}
                {error && (
                    <div style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 8, padding: "12px 16px", marginBottom: 16, fontSize: 13 }}>
                        ⚠ {error}
                    </div>
                )}

                {/* Logs List */}
                {logs.length > 0 && (

                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        <div className="button-group">
                            <button className={actionTypeCode === "" ? "active" : ""} onClick={() => setActionTypeCode("")}>
                                All
                            </button>
                            <button className={actionTypeCode === 101 ? "active" : ""} onClick={() => setActionTypeCode(101)}>
                                {actionTypeLabel(101).icon} Create
                            </button>
                            <button className={actionTypeCode === 102 ? "active" : ""} onClick={() => setActionTypeCode(102)}>
                                {actionTypeLabel(102).icon} Update
                            </button>
                            <button className={actionTypeCode === 103 ? "active" : ""} onClick={() => setActionTypeCode(103)}>
                                {actionTypeLabel(103).icon}  Delete
                            </button>
                        </div>

                        {/* Loop */}
                        {logs.map((log, index) => {
                            if (actionTypeCode !== log.actionType && actionTypeCode != "") {
                                return;
                            }
                            const diffs = getDiff(log.changes, log.oldChanges);
                            // which have no difference not showing only update case
                            // Due to save enity which have no changes
                            if (diffs.length == 0 && log.actionType == 102) {
                                return;
                            }
                            const action = actionTypeLabel(log.actionType);
                            const isExpanded = expandedRow === log.id;
                            const firstDiff = diffs[0];

                            let changesInfo = undefined;
                            try {
                                changesInfo = JSON.parse(log?.changes || log?.oldChanges);
                            } catch (err) { }

                            return (
                                <Fragment key={index}>
                                    <div key={log.id} style={{
                                        background: "#fff",
                                        border: `1.5px solid ${isExpanded ? "#cbd5e1" : "#e2e8f0"}`,
                                        borderRadius: 12,
                                        overflow: "hidden",
                                        boxShadow: isExpanded ? "0 4px 16px rgba(0,0,0,0.08)" : "0 1px 3px rgba(0,0,0,0.04)",
                                        transition: "box-shadow 0.2s, border-color 0.2s",
                                    }}>
                                        {/*  Row Header*/}
                                        <div onClick={() => diffs.length > 0 && toggleRow(log.id)}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 12,
                                                padding: "13px 18px",
                                                cursor: diffs.length > 0 ? "pointer" : "default",
                                                flexWrap: "wrap",
                                            }}>
                                            {/* Action Badge */}
                                            <span style={{
                                                background: action.bg,
                                                color: action.color,
                                                borderRadius: 6,
                                                padding: "3px 11px",
                                                fontWeight: 700,
                                                fontSize: 12,
                                                minWidth: 85,
                                                textAlign: "center",
                                            }}>
                                                {action.icon} {action.label}
                                            </span>

                                            {/* Entity Type */}
                                            <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#f1f5f9", color: "#475569", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", fontFamily: "monospace", fontWeight: 500, border: "1px solid #e2e8f0", }}>
                                                {log.entityType}
                                                <span style={{ background: "#e2e8f0", color: "#23497a", borderRadius: "4px", padding: "1px 6px", fontSize: "11px", fontWeight: 600, letterSpacing: "0.02em", }}>
                                                    {diffs.length > 0 ? firstDiff?.id : changesInfo?.id}
                                                </span>
                                            </span>

                                            <span style={{ fontSize: 13, color: "#64748b", flex: 1, minWidth: 120 }}>
                                                {
                                                    diffs.length === 0
                                                        ? <span style={{ color: "#cbd5e1" }}>No visible changes</span>
                                                        : firstDiff.type === "changed"
                                                            ? <>
                                                                <strong style={{ color: "#334155" }}>{friendlyFieldName(firstDiff.key)}</strong>
                                                                {" "}changed
                                                                {diffs.length > 1 && <span style={{ color: "#94a3b8" }}> +{diffs.length - 1} more</span>}
                                                            </>
                                                            : firstDiff.type === "added"
                                                                ? <>
                                                                    Permission <strong style={{ color: "#15803d" }}>added</strong>
                                                                    {diffs.length > 1 && <span style={{ color: "#94a3b8" }}> +{diffs.length - 1} more</span>}
                                                                </>
                                                                : <>
                                                                    Permission <strong style={{ color: "#b91c1c" }}>removed</strong>
                                                                    {diffs.length > 1 && <span style={{ color: "#94a3b8" }}> +{diffs.length - 1} more</span>}
                                                                </>
                                                }
                                            </span>

                                            <div style={{ display: "flex", alignItems: "center", gap: 14, marginLeft: "auto", flexShrink: 0 }}>

                                                {diffs.length > 0 && (
                                                    <span style={{ fontSize: 11, color: "#3b82f6", fontWeight: 600, background: "#eff6ff", borderRadius: 5, padding: "3px 8px" }}>
                                                        {isExpanded ? "▲ Hide" : "▼ Details"}
                                                    </span>
                                                )}
                                                {diffs.length > 0 && (
                                                    <div>
                                                        <span onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleShowJSON(log?.changes, log?.oldChanges);
                                                        }} style={{ fontSize: 13, color: "#0c966c", fontWeight: 600, background: "#eff6ff", borderRadius: 5, padding: "3px 8px", border: "1px solid #0c966c" }}>
                                                            JSON Preview
                                                        </span>
                                                    </div>
                                                )}
                                                <span style={{ fontSize: 12, color: "#94a3b8" }}>
                                                    by <strong style={{ color: "#752121" }}>{log.changedBy.toUpperCase()}</strong>
                                                </span>
                                                <span style={{ fontSize: 12, color: "#94a3b8" }}>
                                                    {new Date(log.changedOn).toLocaleString("en-IN", {
                                                        day: "2-digit", month: "short", year: "numeric",
                                                        hour: "2-digit", minute: "2-digit",
                                                    })}
                                                </span>

                                            </div>
                                        </div>

                                        {/* <AnimatePresence> */}
                                        {isExpanded && (
                                            <div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: "auto" }}
                                                exit={{ opacity: 0, height: 0 }}
                                                transition={{ duration: 0.2 }}
                                            >
                                                <DiffDetail diffs={diffs} />
                                            </div>
                                        )}
                                        {/* </AnimatePresence> */}
                                    </div>
                                </Fragment>
                            );
                        })}
                    </div>
                )}

                {logs.length === 0 && !loading && !error && (
                    <div style={{ textAlign: "center", padding: "60px 20px", color: "#94a3b8" }}>
                        <div style={{ fontSize: 40, marginBottom: 12 }}>🗂</div>
                        <div style={{ fontWeight: 600, color: "#64748b", fontSize: 15 }}>No logs loaded</div>
                        <div style={{ marginTop: 6, fontSize: 13 }}>Select filters and click Generate Logs</div>
                    </div>
                )}

                {/* Date Picker Modal */}
                <Modal show={show} onHide={() => handleClose(false)} centered size="lg" className="customDate">
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>{t("Select Date Range")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center">

                        <DayPicker
                            mode="range"
                            selected={range}
                            onSelect={setRange}
                            captionLayout="dropdown"
                            numberOfMonths={2}
                            pagedNavigation
                            showOutsideDays
                            startMonth={minDate}
                            endMonth={today}
                            defaultMonth={today}
                            disabled={{
                                before: minDate,
                                after: today
                            }}
                        />
                        {range && (
                            <Button variant="outline-secondary" size="sm" onClick={() => setRange(undefined)} style={{ marginTop: 8 }}>
                                Reset
                            </Button>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={() => handleClose(true)}>Cancel</Button>
                        {range?.from && range?.to && (
                            <Button onClick={applyCustomDate} style={{ background: "#0f172a", border: "none" }}>
                                Apply Range
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>

                {/* Show JSON */}
                <Modal show={showJSON} onHide={() => handleCloseJSON(false)} centered size="lg" className="customDate jsonPreview">
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>{t("JSON Preview")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center">

                        <Row>
                            <Col>
                                <h6>Old Changes</h6>
                                {
                                    jsonChanges?.changes &&
                                    <JsonView value={JSON.parse(jsonChanges?.oldChanges)}
                                        collapsed={1}
                                        enableClipboard={false}
                                        displayDataTypes={false}
                                        indentWidth={5}

                                    />
                                }
                            </Col>
                            <Col>
                                <h6>New Changes</h6>
                                {
                                    jsonChanges?.oldChanges &&
                                    <JsonView value={JSON.parse(jsonChanges?.changes)}
                                        collapsed={1}
                                        enableClipboard={false}
                                        displayDataTypes={false}
                                        indentWidth={5}
                                    />
                                }
                            </Col>
                        </Row>

                    </Modal.Body>
                </Modal>
            </div>
        </FormLoader >
    );
};

export default TrPanelLogs;